import { createTheme } from '@material-ui/core/styles';

const adapifyTheme = createTheme({
  palette: {
    primary: {
      light: '#acff85',
      main: '#79cd55',
      dark: '#469b25',
      contrastText: '#fff',
      gray: '#777',
    },
    secondary: {
      light: '#ccb288',
      main: '#9a835b',
      dark: '#6b5731',
      contrastText: '#fff',
      gray: '#dadada',
    },
  },
  typography: {
    fontFamily: [
      'Montserrat',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },

  // Override MuiTab in theme.js
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '#root': {
          overflow: 'auto',
        },
        body: { margin: 0 },
        '*::-webkit-scrollbar': {
          width: '0.4em',
          height: '0.4em',
          overflow: 'overlay',
        },
        '*::-webkit-scrollbar *': {
          background: 'transparent',
        },
        '*::-webkit-scrollbar-track': {
          display: 'none',
        },
        '*::-webkit-scrollbar-thumb': {
          background: '#a3c755',
          borderRadius: '10px',
        },
      },
    },
    MuiButton: {
      root: {
        borderRadius: 2,
      },
    },
    MuiCard: {
      root: {
        borderRadius: 4,
      },
    },
    MuiListItem: {
      root: {
        '&$selected': {
          backgroundColor: '#7c7c7c',
          '&:hover': {
            backgroundColor: '#a1a1a1',
          },
        },
      },
      button: {
        '&:hover': {
          backgroundColor: '#d5d5d5',
        },
      },
    },
    MuiCardHeader: {
      root: {
        borderRadius: '4px 4px 0 0',
      },
    },
    MuiCardActions: {
      root: {
        borderRadius: '0 0 4px 4px',
      },
    },
    MuiTab: {
      labelIcon: {
        minHeight: 60,
        paddingTop: 12,
      },
    },
    MuiDrawer: {
      paper: {
        backgroundColor: '#484848',
        color: '#fff',
      },
    },
    MuiTableBody: {
      root: {
        overflow: 'auto',
      },
    },
    MuiTableCell: {
      root: {
        minWidth: '140px',
      },
      body: {
        border: 'none',
      },
      footer: {
        borderTop: '1px solid rgba(224, 224, 224, 1)',
        backgroundColor: '#fff',
      },
    },
    MuiInputBase: {
      input: {
        '&:-webkit-autofill': {
          transitionDelay: '9999s',
          transitionProperty: 'background-color, color',
        },
      },
    },
  },
});

export default adapifyTheme;
